<template>
  <div class="m-chat">
    <div class="chat-box" v-if="showChatBox">
      <div class="cb-header">
        <span class="text-a">客户咨询服务</span>
        <img src="@/assets/close01.png" alt="" @click="showChatBox = false">
      </div>
      <div class="cb-content">
        <div class="cbc-item">
          <img class="icon-c" src="@/assets/avator11.png" alt="">
          <div>
            <p><span class="text-b">客服1号</span> <span class="text-c">{{adminTime}}</span></p>
            <p class="text-d">您好，请问有什么可以问题需要咨询？</p>
          </div>
        </div>
        <ul v-for="(item,index) in answers" :key="index">
          <li class=" cbc-item-b">
            <div>
              <p><span class="text-c">{{item.time}}</span> <span class="text-b">{{item.nickName}}</span></p>
              <p class="text-e">{{item.keyword}}</p>
            </div>
            <img class="icon-c" src="@/assets/avator12.png" alt="">
          </li>
          <li class="cbc-item">
            <img class="icon-c" src="@/assets/avator11.png" alt="">
            <div>
              <p><span class="text-b">客服1号</span> <span class="text-c">{{item.answers}}</span></p>
              <p><span class="text-c">{{item.time}}</span> <span class="text-b">{{item.nickName}}</span></p>
              <p class="text-d">{{item.answer}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="cb-send">
        <textarea class="cbs-input" cols="30" rows="2" v-model="question"></textarea>
        <div class="cbs-btns">
          <span class="cbs-btn" @click="toQuery(question)">发送</span>
        </div>
      </div>
    </div>
    <div class="icon-a" v-else @click="showChatBoxTap">
      <img class="icon-b" src="@/assets/mchat.png" alt="">
    </div>
  </div>
</template>

<script>
import HttpConnectionC from "@/utils/HttpConnectionC";
let _answerTemp = [];
let _keyword = []
export default {
  name: "MChat",
  data () {
    return {
      showChatBox: false,
      consultList: [],
      answers: [],
      question: "",
      showAnswer: true,
      nickName: "",
      adminTime: "",
      keyword: []
    }
  },
  methods: {
    getConsultList () {
      let that = this;
      that.nickName = that.$store.state.user.userInfo.nickName;
      HttpConnectionC.get("/homepage/listMsg").then(function (response) {
        that.consultList = response.rows;
      });
    },
    toQuery (keyword) {
      let that = this;
      if (keyword.replace(/(^\s*)|(\s*$)/g, "").length == 0) {
        let date = new Date();
        var Hours = date.getHours();
        var Minutes = date.getMinutes();
        if (Hours > 9) {
          Hours = Hours;
        } else {
          Hours = '0' + Hours;
        }
        if (Minutes > 9) {
          Minutes = Minutes;
        } else {
          Minutes = '0' + Minutes;
        }
        let _time = Hours + ":" + Minutes;
        _answerTemp.push({
          time: _time,
          answer: "抱歉请您输入想询问的内容",
        });
        that.answers = _answerTemp;
        that.question = '';
      } else {
        HttpConnectionC.get(`/homepage/listMsgByKeyword/${keyword}`).then(function (response) {
          let date = new Date();
          var Hours = date.getHours();
          var Minutes = date.getMinutes();
          if (Hours > 9) {
            Hours = Hours;
          } else {
            Hours = '0' + Hours;
          }
          if (Minutes > 9) {
            Minutes = Minutes;
          } else {
            Minutes = '0' + Minutes;
          }
          let _time = Hours + ":" + Minutes;
          if (response.total > 0) {
            _answerTemp.push({
              time: _time,
              answer: response.rows[0].answer,
              keyword: keyword
            });
          } else {
            _answerTemp.push({
              time: _time,
              keyword: keyword,
              answer: "抱歉，无法为您找到满意的答案"
            });
          }
          that.answers = _answerTemp;
          that.question = '';
          that.showAnswer = true;
        });
      }
    },
    showChatBoxTap () {
      this.showChatBox = true;
      this.getConsultList();
      let date = new Date();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      if (Hours > 9) {
        Hours = Hours;
      } else {
        Hours = '0' + Hours;
      }
      if (Minutes > 9) {
        Minutes = Minutes;
      } else {
        Minutes = '0' + Minutes;
      }
      this.adminTime = Hours + ":" + Minutes;
    }
  }
};
</script>

<style scoped lang="scss">
.chat-box {
  width: 360px;
  box-shadow: 0px 0px 30px rgba(145, 169, 255, 0.4);
  position: fixed;
  right: 30px;
  bottom: 60px;
  z-index: 4;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  .cb-header {
    width: 360px;
    height: 48px;
    background-color: #91a9ff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 14px 0px 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  .cb-content {
    width: 360px;
    height: 365px;
    padding: 16px;
    background-color: #ffffff;
    overflow-y: scroll;
    .cbc-item {
      display: flex;
      flex-direction: row;
      margin: 6px 0px 0px 0px;
    }
    .cbc-item-b {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 6px 0px 0px 0px;
    }
  }
  .cb-send {
    width: 360px;
    border-top: 1px solid #e6e6e6;
    background-color: #ffffff;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    .cbs-input {
      width: 328px;
      margin: 8px 16px;
    }
    .cbs-btns {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      padding: 0px 16px 8px 16px;
    }
    .cbs-btn {
      width: 40px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      background: #91a9ff;
      border-radius: 4px;
      color: #ffffff;
      font-weight: 400;
      font-size: 12px;
      cursor: pointer;
      user-select: none;
    }
  }
}
.icon-a {
  width: 56px;
  height: 56px;
  background: #91a9ff;
  box-shadow: 0px 8px 30px rgba(38, 88, 254, 0.4);
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 30px;
  bottom: 60px;
}
.icon-b {
  width: 28px;
  height: 28px;
}
.icon-c {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}
.text-a {
  font-weight: 400;
  color: #ffffff;
  font-size: 14px;
}
.text-b {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
.text-c {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
}
.text-d {
  width: 213px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #333333;
  border: 1px solid #999999;
  padding: 7px;
  border-radius: 4px;
  margin: 4px 0px 0px 0px;
}
.text-e {
  max-width: 230px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #ffffff;
  background-color: #91a9ff;
  padding: 7px;
  border-radius: 4px;
  margin: 4px 0px 0px 0px;
  word-break: break-all;
}
.text-f {
  width: 213px;
  border: 1px solid #999999;
  padding: 7px;
  border-radius: 4px;
  margin: 4px 0px 0px 0px;
  li {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    margin: 4px 0px;
    cursor: pointer;
  }
  li:hover {
    color: #3d6fd8;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-decoration-line: underline;
  }
}
</style>
